<template>
    <div>
        <app-mystaffform v-if="list"
        v-bind:parentObject="{
            list: this.list,
            roleName: this.roleName
        }"
        />
    </div>
</template>

<script>

import mystaffForm from '../../sscomponents/performance/MyStaffForm.vue';

export default {

    components: {
        'app-mystaffform': mystaffForm,
    },

    data() {
        return {
            list: this.$route.params.list,
            roleName: this.$route.params.roleName
        }

        
    },

    methods: {
        
    },

    mounted() {
        console.log("Selected list:", this.list);
    }
}

</script>